// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";

// Define a service using a base URL and expected endpoints
export const goalMetricsAPI = createApi({
  reducerPath: "goalMetricsAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    createGoalMetric: builder.mutation<any, GoalMetricArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/goal/action/metric/create`,
        method: "POST",
        data: payload,
      }),
    }),
    updateGoalMetric: builder.mutation<any, GoalMetricArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/goal/action/metric/update`,
        method: "POST",
        data: payload,
      }),
    }),
    updateGoalMetricStatus: builder.mutation<any, GoalMetricsStatusArgTypes>({
      query: ({ affiliateCode, aboNumber, goalMetricId, statusId }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/goal/action/metric/${goalMetricId}/update/status/${statusId}`,
        method: "POST",
      }),
    }),
    deleteGoalMetric: builder.mutation<any, GoalsMetricDeleteArgsType>({
      query: ({ metricId }) => ({
        url: `/am/abo/goal/action/metric/${metricId}`,
        method: "DELETE",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateGoalMetricMutation,
  useUpdateGoalMetricMutation,
  useUpdateGoalMetricStatusMutation,
  useDeleteGoalMetricMutation,
} = goalMetricsAPI;
